export function useMolLinkInSearchResult() {
  return true;
}

export function showKeywordFilter() {
  return true;
}

export function showForceLagerFilter() {
  return false;
}

export function showMediumInSearchPage() {
  return false;
}
